import {SET_DAILY_PERCENT} from "../../enums/Employees/employees.types";

export const setDailyPercentAction = (data) => {
    return {
        type: SET_DAILY_PERCENT,
        payload: data,
    };
};
